// shared
import req from 'shared/req';
import {errorMessage} from 'shared/actions/notifications';
import GoogleOAuth from 'shared/modules/google-oauth';

export const onSubmit = (values) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return req({
      url: '/v1/authenticate',
      method: 'post',
      data: values
    }).then((res) => {
      window.location = res.url;
      resolve();
    }).catch((data) => {
      const {errors: {basic}} = data;

      if (basic) {
        reject({
          identifier: basic,
          password: basic
        });
      } else {
        dispatch(errorMessage());
        reject();
      }
    });
  });
};

export const googleLogin = () => (dispatch) => {
  GoogleOAuth.authorize().then((googleUser) => {
    return req({
      url: '/auth/google/login',
      method: 'post',
      data: {token: googleUser.getAuthResponse().id_token}
    }).then((res) => {
      window.location = res.url;
    }).catch((data) => {
      dispatch(errorMessage(data.errors.google));
    });
  });
};
